import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { memo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import config from '../../../../config';
import { changeLocale } from '../../../../ducks/locale.duck';
import { FormattedMessage } from '../../../../util/reactIntl';
import IconDenmark from '../../../Icons/Countries/IconDenmark';
import IconFrance from '../../../Icons/Countries/IconFrance';
import IconGermany from '../../../Icons/Countries/IconGermany';
import IconItaly from '../../../Icons/Countries/IconItaly';
import IconNorway from '../../../Icons/Countries/IconNorway';
import IconSpain from '../../../Icons/Countries/IconSpain';
import IconSweden from '../../../Icons/Countries/IconSweden';
import IconUK from '../../../Icons/Countries/IconUK';
import IconLanguage from '../../../Icons/IconLanguage';

const LanguageMenuComponent = () => {
  const [languageMenuButtonEl, setLanguageMenuButtonEl] = useState(null);
  const languageMenuOpen = Boolean(languageMenuButtonEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  const handleLanguageChange = (locale) => {
    setLanguageMenuButtonEl(null);
    dispatch(changeLocale(locale, navigate, location));
  };

  const localeIcons = {
    de: <IconGermany />,
    en: <IconUK />,
    sv: <IconSweden />,
    da: <IconDenmark />,
    fr: <IconFrance />,
    it: <IconItaly />,
    es: <IconSpain />,
    no: <IconNorway />,
  };

  return (
    <Box>
      <IconButton
        aria-controls={languageMenuOpen ? 'language-menu' : undefined}
        aria-expanded={languageMenuOpen ? 'true' : undefined}
        aria-haspopup="true"
        aria-label="select language button"
        component="div"
        id="language-menu-button"
        onClick={(e) => setLanguageMenuButtonEl(e.currentTarget)}
      >
        <IconLanguage />
      </IconButton>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'language-menu-button',
        }}
        anchorEl={languageMenuButtonEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        disableScrollLock
        id="language-menu"
        onClose={() => setLanguageMenuButtonEl(null)}
        open={languageMenuOpen}
        transformOrigin={{
          vertical: -16,
          horizontal: 'right',
        }}
      >
        {Object.keys(config.languages).map((locale) => (
          <MenuItem
            key={locale}
            onClick={() => handleLanguageChange(locale)}
            selected={intl.locale === locale}
          >
            <Box mr={1}>{localeIcons[locale] || null}</Box>
            <FormattedMessage id={`Language.${locale}`} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

LanguageMenuComponent.displayName = 'LanguageMenu';
const LanguageMenu = memo(LanguageMenuComponent);

export default LanguageMenu;
